import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import styled, { css } from 'styled-components';

const colorMapper = {
  initial: `
    color: initial;
  `,
  inherit: `
    color: inherit;
  `,
  primary: css`
    color: ${(props) => props.theme.palette.primary.main};

    &:hover {
      color: ${(props) => props.theme.palette.primary.dark};
    }
  `,
  textPrimary: css`
    color: ${(props) => props.theme.palette.text.primary};

    &:hover {
      color: ${(props) => props.theme.palette.text.primaryHover};
    }
  `,
  textSecondary: css`
    color: ${(props) => props.theme.palette.text.secondary};

    &:hover {
      color: ${(props) => props.theme.palette.text.secondaryHover};
    }
  `,
  error: css`
    color: ${(props) => props.theme.palette.error.main};

    &:hover {
      color: ${(props) => props.theme.palette.error.dark};
    }
  `
};

const underlineMapper = {
  none: `
    text-decoration: none
  `,
  hover: `
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `,
  always: `
    text-decoration: underline;
  `
};

const LinkRoot = styled.a.withConfig<Props>({
  shouldForwardProp: (props: string) => !['color', 'underline'].includes(props)
})`
  ${({ underline }) => underline && underlineMapper[underline]};

  ${({ color }) => color && colorMapper[color]};
`;

export interface Props extends Omit<NavLinkProps, 'to'> {
  underline?: 'none' | 'hover' | 'always';
  color?: 'initial' | 'inherit' | 'primary' | 'textPrimary' | 'textSecondary' | 'error';
  to?: string;
}

export const Link = React.forwardRef<HTMLAnchorElement, Props>(function Link(props: Props, ref) {
  const { children, color = 'textPrimary', underline = 'none', to, ...rest } = props;

  const Component = to ? NavLink : 'a';

  return (
    /** @ts-expect-error - TODO fix to better api */
    <LinkRoot ref={ref} as={Component} color={color} underline={underline} to={to} {...rest}>
      {children}
    </LinkRoot>
  );
});

export default Link;
